export default "__VITE_ASSET__7d4f6928__"